import { useEffect } from 'react';
import { isIOS } from 'react-device-detect';

import ProfileStore from 'stores/ProfileStore';


export const ORIENTATION = {
  PORTRAIT: 'portrait',
  LANDSCAPE: 'landscape',
};

const getOrientationByWindowSize = () => {
  const { clientHeight, clientWidth } = document.documentElement || {};
  if (clientHeight >= clientWidth) {
    return ORIENTATION.PORTRAIT;
  }

  return ORIENTATION.LANDSCAPE;
};

const getOrientationByAngle = (angle) => {
  if (Math.abs(angle) > 0) {
    return ORIENTATION.LANDSCAPE;
  }

  return ORIENTATION.PORTRAIT;
};

export default function useOrientation() {
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (isIOS) {
      // Calculate orientation on initial load on ios devices
      const orientationInitial = getOrientationByWindowSize();
      ProfileStore.toggleDeviceInLandscape(orientationInitial === ORIENTATION.LANDSCAPE);
      // if iOS device is used resize mechanism to determine orientation, since orientationchange not works.
      const resizeHandler = () => {
        const orientation = getOrientationByWindowSize();
        ProfileStore.toggleDeviceInLandscape(orientation === ORIENTATION.LANDSCAPE);
      };

      window.addEventListener('resize', resizeHandler);

      return () => window.removeEventListener('resize', resizeHandler);
    }

    if (Object.hasOwn(window, 'onorientationchange')) {
      // Calculate orientation on initial load on android devices
      let orientationAngleInitial = undefined;
      if (Object.hasOwn(window, 'orientation')) {
        orientationAngleInitial = window.orientation;
      } else if (
        Object.hasOwn(window, 'screen') &&
        Object.hasOwn(window.screen, 'orientation')
      ) {
        orientationAngleInitial = window.screen.orientation;
      } else {
        orientationAngleInitial = 0;
      }

      const orientationInitial = getOrientationByAngle(orientationAngleInitial);
      ProfileStore.toggleDeviceInLandscape(orientationInitial === ORIENTATION.LANDSCAPE);

      // if not iOS device, which means android use orientationchange which work correct for android,
      // since resize not works on android
      // because android change viewport size when keyboard is active and can't be used resize method.
      const orientationChangeHandler = (event) => {
        const angle = Math.abs(event.target.screen.orientation.angle);
        const orientation = getOrientationByAngle(angle);
        ProfileStore.toggleDeviceInLandscape(orientation === ORIENTATION.LANDSCAPE);
      };

      window.addEventListener('orientationchange', orientationChangeHandler);

      return () => window.removeEventListener('orientationchange', orientationChangeHandler);
    }
  }, []);
}
